import { createHook } from 'react-sweet-state';

import { Store } from '../main';

export const useSite = createHook(Store);
export const useCloudId = (): string => useSite()[0].cloudId;
